import { __awaiter, __generator, __read, __spread } from "tslib";
import { IDLE_LOW_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import { APP_WORKLOAD, APP_WORKLOAD_TYPE, AUDIENCE_GROUP, BROWSER_SESSION_ID, DEPLOYMENT_ENV, DEVICE_TYPE, DOMAIN_ORIGIN, ECS_RING, EVENT_SCHEMA_VERSION, FIRST_VISIT_AGE_IN_DAYS, FLIGHTS, INITIAL_PAGE_NAME, IS_ADMIN, IS_DYNAMICS, IS_EDU, IS_EDU_FACULTY, IS_EDU_STUDENT, IS_FIRST_VISIT, IS_IW, IS_SMB, NETWORK_TYPE, RELEASE, REQUEST_ORIGIN, SCHEMA_VERSION, SERVER_LOCATION, SERVICE_WORKER_STATE, USER_SEGMENT, } from '@office-start/telemetry-types';
import { EventQueue, getFlattenedFieldName, isGuid, } from '@office-start/telemetry-utility';
import { addUnloadEvent } from '@office-start/unload-utility';
var App;
var Session;
var User;
var DataCategories;
var DiagnosticLevel;
var loggerEnabled = false;
var loggerInitialized = false;
var nameSpace = '';
var telemetryLogger;
var telemetryLoggerModule;
var unAuthLoggerEnabled = false;
var unAuthLoggerInitialized = false;
var unAuthTelemetryLogger;
var unAuthOneDsSink;
var makeBooleanDataField;
var makeInt64DataField;
var makeStringDataField;
var oneDsSinkModule;
var oneDsEndpointModule;
var oneDsSink;
var osPlugin;
var persistentFields;
var suppressNexus;
var eventQueue = new EventQueue();
var unAuthEventQueue = new EventQueue();
var oneDsSinkPromiseResolver;
export var authOneDsSinkPromise = new Promise(function (resolve) {
    oneDsSinkPromiseResolver = resolve;
});
/**
 * Function to delay-load OTELJS and initialize anonymous OTelTelemetry logger.
 *
 * TODO: Add tests, validation of event field and anonymous OTelTelemetry logger initialization
 *
 * @param appName - Human-readable name of the app that generated this event, for example: OfficeHub
 * @param appPlatform - The hardware/software environment that was used to perform actions in the app or service.
 * @param appWorkload - Workload, allow list should be either Edge/HWA/PWA/Web/Embed
 * @param bundleBuildDate - bundle Build date, in format yyyy-mm-dd HH:mm:ss.sss
 * @param bundleBuildId - Guid in format xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
 * @param correlationId - Guid, associated with office.com page visit in format xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
 * @param deploymentEnvironment - deployment environment, used for separate test or prod data
 * @param deviceType: DeviceType
 * @param flights: list of flights and features
 * @param oTelEnabled - flag indicating whether the OTel telemetryLogger should be enabled or not
 * @param isCorpNet - flag indicating whether in CorpNet or not
 * @param isTestTraffic - flag indicating whether the traffic is test traffic or not
 * @param oTelAriaTenant - Office Aria tenant token
 * @param oTelAriaNameSpace - Office Aria tenant, for example: Office.Taos.Hub
 * @param sessionId - Guid, for this process session in format xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
 * @param serverLocation - server geo location
 * @param requestOrigin - Determine where traffic came from, this value is from an allow list.
 * @param userType - Determine the type of user New/Returning/SignOut/Other
 * @param win11DetectionEnabled - Windows 11 cannot be detected using the browser agent string. A flag indicating whether the client-side detection logic should be enabled or not
 *
 */
export function initializeUnAuthOTel(appName, appPlatform, appWorkload, bundleBuildDate, bundleBuildId, correlationId, deploymentEnvironment, deviceType, flights, isCorpNet, isTestTraffic, oTelEnabled, oTelAriaTenant, oTelAriaNameSpace, sessionId, serverLocation, requestOrigin, userType, win11DetectionEnabled) {
    if (win11DetectionEnabled === void 0) { win11DetectionEnabled = true; }
    if (!(oTelEnabled && oTelAriaTenant) ||
        !isValidConfig(correlationId, sessionId) ||
        unAuthLoggerInitialized) {
        return Promise.resolve();
    }
    unAuthLoggerEnabled = true;
    nameSpace = oTelAriaNameSpace;
    return Promise.all([downloadOTel(), downloadOneDs()])
        .then(function () {
        unAuthTelemetryLogger = new telemetryLoggerModule(undefined, undefined, {
            enableQueue: true,
        });
        unAuthTelemetryLogger.setTenantToken(oTelAriaNameSpace, oTelAriaTenant, suppressNexus);
        persistentFields = getPartAFields(appName, appPlatform, appWorkload, bundleBuildDate, correlationId, deploymentEnvironment, deviceType, flights, isCorpNet, isTestTraffic, sessionId, serverLocation, requestOrigin, true, // isAnonymous
        undefined, undefined);
        // TODO: Add Privacy Guard to oneDsSink https://www.owiki.ms/wiki/Telemetry/Privacy/Privacy_Guard
        if (win11DetectionEnabled) {
            getSinkOsPlugin().then(function (sinkOsPlugin) {
                unAuthOneDsSink = new oneDsSinkModule(persistentFields, {
                    endpointUrl: getOneDsEndpoint(deploymentEnvironment),
                    plugins: [sinkOsPlugin],
                });
            });
        }
        else {
            unAuthOneDsSink = new oneDsSinkModule(persistentFields, {
                endpointUrl: getOneDsEndpoint(deploymentEnvironment),
            });
        }
        unAuthTelemetryLogger.addSink(unAuthOneDsSink);
        unAuthLoggerInitialized = true;
        drainQueuedEvents(true);
    })
        .catch(function () {
        // logger initialization failed, set loggerEnabled to false to prevent buffering events to queue
        unAuthLoggerEnabled = false;
    });
}
/**
 * Function to delay-load OTELJS and initialize non-anonymous OTelTelemetry logger.
 *
 * TODO: Add tests, validation of event field and anonymous OTelTelemetry logger initialization
 *
 * @param appName - Human-readable name of the app that generated this event, for example: OfficeHub
 * @param appPlatform - The hardware/software environment that was used to perform actions in the app or service.
 * @param appWorkload - Workload allow list should be either Edge/HWA/PWA/Web/Embed
 * @param bundleBuildDate - Client bundle Build date, in format yyyy-mm-dd HH:mm:ss.sss
 * @param bundleBuildId - Guid in format xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
 * @param correlationId - Guid, associated with office.com page visit in format xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
 * @param deviceType: DeviceType
 * @param deploymentEnvironment - deployment environment, used for separate test or prod data
 * @param flights - list of flights and features
 * @param identity - OfficeIdentity info
 * @param isCorpNet - flag indicating whether in CorpNet or not
 * @param isTestTraffic - flag indicating whether the traffic is test traffic or not
 * @param oTelEnabled - flag indicating whether the OTel telemetryLogger should be enabled or not
 * @param oTelAriaTenant - Office Aria tenant token
 * @param oTelAriaNameSpace - Office Aria tenant, for example: Office.Taos.Hub
 * @param sessionId - Guid, for this process session in format xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
 * @param serverLocation - server geo location
 * @param platformType: PlatformType
 * @param requestOrigin - Determine where traffic came from, this value is from an allow list.
 * @param userSegment - userSegment info
 * @param ecsRing - Current ECS Ring that user belongs to (Preproduction, TaosInternal, Microsoft, FirstRelease, WorldWide)
 * @param appWorkloadType - Workload Type allow list should be either WebView2/UWP/UWP_fallback
 * @param networkType - Network Type (Slow2g, Standard2g, Standard3g, Standard4g, Unknown)
 * @param serviceWorkerState - Service Worker State (Controlled, SupportedNotControlled, Unknown, Unsupported)
 * @param firstVisitAgeInDays - Number of full days that passed since user visited office.com for the first time.
 * @param win11DetectionEnabled - Windows 11 cannot be detected using the browser agent string. A flag indicating whether the client-side detection logic should be enabled or not
 * @param domainOrigin - Which domain was accessed to get to the unauth and auth page of Office
 * @param initialPageName - initial PageName
 * @param dataBoundary - Data boundary of the tenant
 * @param IsEudbEndpointEnabled - An ecs flag to determine whether we should initialize the 1DS sink with EUDB endpoint.
 */
export function initializeOTel(appName, appPlatform, appWorkload, bundleBuildDate, bundleBuildId, correlationId, deploymentEnvironment, deviceType, flights, identity, isCorpNet, isTestTraffic, oTelEnabled, oTelAriaTenant, oTelAriaNameSpace, sessionId, serverLocation, requestOrigin, userSegment, ecsRing, appWorkloadType, schedulerPriority, networkType, serviceWorkerState, firstVisitAgeInDays, win11DetectionEnabled, domainOrigin, initialPageName, dataBoundary, IsEudbEndpointEnabled) {
    if (win11DetectionEnabled === void 0) { win11DetectionEnabled = true; }
    if (!(oTelEnabled && oTelAriaTenant) ||
        !isValidConfig(correlationId, sessionId, identity.tenantId) ||
        loggerInitialized) {
        return Promise.resolve();
    }
    loggerEnabled = true;
    nameSpace = oTelAriaNameSpace;
    return Promise.all([
        downloadOTel(schedulerPriority),
        downloadOneDs(schedulerPriority),
    ])
        .then(function () {
        telemetryLogger = new telemetryLoggerModule(undefined, undefined, {
            enableQueue: win11DetectionEnabled,
        });
        telemetryLogger.setTenantToken(oTelAriaNameSpace, oTelAriaTenant, suppressNexus);
        persistentFields = getPartAFields(appName, appPlatform, appWorkload, bundleBuildDate, correlationId, deploymentEnvironment, deviceType, flights, isCorpNet, isTestTraffic, sessionId, serverLocation, requestOrigin, false, // authenticated
        identity, userSegment, ecsRing, appWorkloadType, networkType, serviceWorkerState, firstVisitAgeInDays, domainOrigin, initialPageName);
        // TODO: Add Privacy Guard to oneDsSink https://www.owiki.ms/wiki/Telemetry/Privacy/Privacy_Guard
        if (win11DetectionEnabled) {
            getSinkOsPlugin().then(function (sinkOsPlugin) {
                oneDsSink = new oneDsSinkModule(persistentFields, {
                    endpointUrl: getOneDsEndpoint(deploymentEnvironment, dataBoundary, IsEudbEndpointEnabled),
                    plugins: [sinkOsPlugin],
                });
                oneDsSinkPromiseResolver(oneDsSink);
                telemetryLogger.addSink(oneDsSink);
                loggerInitialized = true;
                drainQueuedEvents(false);
                addUnloadEvent(function () {
                    endSession(false);
                }, true);
            });
        }
        else {
            oneDsSink = new oneDsSinkModule(persistentFields, {
                endpointUrl: getOneDsEndpoint(deploymentEnvironment, dataBoundary, IsEudbEndpointEnabled),
            });
            oneDsSinkPromiseResolver(oneDsSink);
            telemetryLogger.addSink(oneDsSink);
            loggerInitialized = true;
            drainQueuedEvents(false);
            addUnloadEvent(function () {
                endSession(false);
            }, true);
        }
    })
        .catch(function () {
        // logger initialization failed, set loggerEnabled to false to prevent buffering events to queue
        loggerEnabled = false;
    });
}
function downloadOTel(schedulerPriority) {
    return new Promise(function (resolve, reject) {
        scheduleWork(function () {
            import(/* webpackChunkName: "oteljs" */ '@microsoft/oteljs')
                .then(function (oteljs) {
                App = oteljs.App;
                Session = oteljs.Session;
                User = oteljs.User;
                makeBooleanDataField = oteljs.makeBooleanDataField;
                makeInt64DataField = oteljs.makeInt64DataField;
                makeStringDataField = oteljs.makeStringDataField;
                telemetryLoggerModule = oteljs.TelemetryLogger;
                suppressNexus = oteljs.SuppressNexus;
                resolve();
            })
                .catch(function (err) {
                reject(err);
            });
        }, schedulerPriority !== null && schedulerPriority !== void 0 ? schedulerPriority : IDLE_LOW_PRIORITY);
    });
}
function downloadOneDs(schedulerPriority) {
    return new Promise(function (resolve, reject) {
        scheduleWork(function () {
            import(/* webpackChunkName: "oteljs1ds" */ '@microsoft/oteljs-1ds')
                .then(function (_a) {
                var OneDSEndpoint = _a.OneDSEndpoint, OneDSSink = _a.OneDSSink, OsPlugin = _a.OsPlugin;
                oneDsSinkModule = OneDSSink;
                oneDsEndpointModule = OneDSEndpoint;
                osPlugin = OsPlugin;
                resolve();
            })
                .catch(function (err) {
                reject(err);
            });
        }, schedulerPriority !== null && schedulerPriority !== void 0 ? schedulerPriority : IDLE_LOW_PRIORITY);
    });
}
function getSinkOsPlugin() {
    return __awaiter(this, void 0, void 0, function () {
        var plugin;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    plugin = new osPlugin();
                    return [4 /*yield*/, plugin.detectOs()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, plugin];
            }
        });
    });
}
/**
 * Function used to either send the event immediately when the telemetry logger is available
 * or buffer it until the telemetry logger is ready
 *
 * @param eventName Event name, used to construct fully qualified name
 * @param properties Additional data properties for event
 *
 */
export function sendEvent(eventName, properties) {
    sendEventCommon(eventName, properties, false);
}
/**
 * Function used to either send the event immediately when the anonymous telemetry logger is available
 * or buffer it until the telemetry logger is ready
 *
 * @param eventName Event name, used to construct fully qualified name
 * @param properties Additional data properties for event
 *
 */
export function sendUnAuthEvent(eventName, properties) {
    sendEventCommon(eventName, properties, true);
}
function sendEventCommon(eventName, properties, isAnonymous) {
    if (isAnonymous ? !unAuthLoggerEnabled : !loggerEnabled) {
        return;
    }
    if (isAnonymous ? unAuthLoggerInitialized : loggerInitialized) {
        // Event.Name: Office.Taos.Hub.<eventName> Event name follows a hierarchical name matching the tenant's name
        var fullyQualifiedName = [nameSpace, eventName].join('.');
        // Part C fields: Different for each event category
        //   - EventCategory
        //   - <EventCategory>Details (PageViewDetails.PageName, PageViewDetails.PageType, PageViewDetails.IsIntentional)
        var dataFields = convertToDataFields(properties);
        sendTelemetryEvent(isAnonymous ? unAuthTelemetryLogger : telemetryLogger, fullyQualifiedName, dataFields, 2 /* ProductServiceUsage */, 110 /* RequiredServiceData */);
    }
    else {
        var event_1 = {
            eventName: eventName,
            params: properties,
        };
        isAnonymous
            ? unAuthEventQueue.queueEvent(event_1)
            : eventQueue.queueEvent(event_1);
    }
}
function sendTelemetryEvent(logger, eventName, dataFields, dataCategories, diagnosticLevel) {
    logger.sendTelemetryEvent({
        eventName: eventName,
        dataFields: dataFields,
        eventFlags: {
            dataCategories: dataCategories,
            diagnosticLevel: diagnosticLevel,
        },
    });
}
/**
 *  Function to generate telemetry fields to be sent on every event.
 *  Part A fields: common fields, these fields should be set on the 1DS sink and cannot be changed
 *    - Required Part A: Fields are required for events that can be processed in COSMOS (App, Session and User)
 *         - App (App.Platform, App.Name)
 *         - Session (Session.Id): use correlationId as primary id
 *         - User (User.IsAnonymous, User.PrimaryIdentityHash, User.PrimaryIdentitySpace, User.TenantGroup, User.TenantId)
 *         - Release (Release.AudienceGroup)
 *    - Customize Part A:
 *         - EventSchemaVersion
 *         - RequestOrigin
 *         - SessionId
 *         - UserSegment (UserSegment.IsAdmin, UserSegment.IsDynamics, UserSegment.IsEdu, UserSegment.IsEduFaculty, UserSegment.IsEduStudent, UserSegment.IsFirstVisit, UserSegment.IsIw, UserSegment.IsSmb)
 */
export function getPartAFields(appName, appPlatform, appWorkload, bundleBuildDate, correlationId, deploymentEnvironment, deviceType, flights, isCorpNet, isTestTraffic, sessionId, serverLocation, requestOrigin, isAnonymous, identity, userSegment, ecsRing, appWorkloadType, networkType, serviceWorkerState, firstVisitAgeInDays, domainOrigin, initialPageName) {
    // version : in format yyyymmd.x
    // TODO: Figure out a way to generate the version number
    var VERSION = '0';
    var buildDate = bundleBuildDate.split(' ')[0].split('-').join('');
    var appVersion = [buildDate, VERSION].join('.');
    var requiredPartADataFields = __spread(App.getFields({
        platform: appPlatform,
        name: appName,
        version: appVersion,
    }), Session.getFields({
        id: correlationId,
    }), [
        makeStringDataField(getFlattenedFieldName([RELEASE, AUDIENCE_GROUP]), getReleaseAudienceGroup(deploymentEnvironment, isCorpNet, isTestTraffic)),
        makeStringDataField(DEPLOYMENT_ENV, deploymentEnvironment),
    ]);
    if (isAnonymous) {
        requiredPartADataFields.push.apply(requiredPartADataFields, __spread(User.getFields({
            isAnonymous: true,
        })));
    }
    else {
        var puid = identity === null || identity === void 0 ? void 0 : identity.puid;
        var idSpace = '';
        if (puid) {
            idSpace = (identity === null || identity === void 0 ? void 0 : identity.isMsa) ? 'MsaPuid' : 'OrgIdPuid';
        }
        requiredPartADataFields.push.apply(requiredPartADataFields, __spread(User.getFields({
            primaryIdentityHash: puid,
            primaryIdentitySpace: idSpace,
            tenantId: identity === null || identity === void 0 ? void 0 : identity.tenantId,
            tenantGroup: (identity === null || identity === void 0 ? void 0 : identity.isMsa) ? 'Consumer' : 'Commercial',
            isAnonymous: false,
        })));
    }
    var customPartADataFields = [
        makeStringDataField(EVENT_SCHEMA_VERSION, SCHEMA_VERSION),
        makeStringDataField(REQUEST_ORIGIN, requestOrigin),
        makeStringDataField(BROWSER_SESSION_ID, sessionId),
        makeStringDataField(APP_WORKLOAD, appWorkload),
        makeStringDataField(SERVER_LOCATION, serverLocation),
        makeStringDataField(DEVICE_TYPE, deviceType),
    ];
    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isAdmin) {
        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_ADMIN]), userSegment.isAdmin));
    }
    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isDynamics) {
        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_DYNAMICS]), userSegment.isDynamics));
    }
    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isEdu) {
        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_EDU]), userSegment.isEdu));
    }
    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isEduFaculty) {
        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_EDU_FACULTY]), userSegment.isEduFaculty));
    }
    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isEduStudent) {
        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_EDU_STUDENT]), userSegment.isEduStudent));
    }
    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isFirstVisit) {
        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_FIRST_VISIT]), userSegment.isFirstVisit));
    }
    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isIw) {
        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_IW]), userSegment.isIw));
    }
    if (userSegment === null || userSegment === void 0 ? void 0 : userSegment.isSmb) {
        customPartADataFields.push(makeBooleanDataField(getFlattenedFieldName([USER_SEGMENT, IS_SMB]), userSegment.isSmb));
    }
    if (flights) {
        customPartADataFields.push(makeStringDataField(FLIGHTS, flights));
    }
    if (appWorkloadType) {
        customPartADataFields.push(makeStringDataField(APP_WORKLOAD_TYPE, appWorkloadType));
    }
    if (ecsRing) {
        customPartADataFields.push(makeStringDataField(ECS_RING, ecsRing));
    }
    if (networkType) {
        customPartADataFields.push(makeStringDataField(NETWORK_TYPE, networkType));
    }
    if (serviceWorkerState) {
        customPartADataFields.push(makeStringDataField(SERVICE_WORKER_STATE, serviceWorkerState));
    }
    if (firstVisitAgeInDays) {
        customPartADataFields.push(makeInt64DataField(FIRST_VISIT_AGE_IN_DAYS, firstVisitAgeInDays));
    }
    if (domainOrigin) {
        customPartADataFields.push(makeStringDataField(DOMAIN_ORIGIN, domainOrigin));
    }
    if (initialPageName) {
        customPartADataFields.push(makeStringDataField(INITIAL_PAGE_NAME, initialPageName));
    }
    var partADataFields = __spread(requiredPartADataFields, customPartADataFields);
    return partADataFields;
}
function getOneDsEndpoint(deploymentEnvironment, dataBoundary, IsEudbEndpointEnabled) {
    if (dataBoundary === 'EU' && IsEudbEndpointEnabled) {
        return oneDsEndpointModule.EUDB;
    }
    switch (deploymentEnvironment) {
        case "pfprod" /* PFProd */:
            return oneDsEndpointModule.USGOV_DOD;
        case "tbprod" /* TBProd */:
            return oneDsEndpointModule.USGOV_DOJ;
        default:
            return oneDsEndpointModule.PUBLIC;
    }
}
export function getReleaseAudienceGroup(deploymentEnvironment, isCorpNet, isTestTraffic) {
    if (isTestTraffic) {
        return 'Automation';
    }
    switch (deploymentEnvironment) {
        case "dev" /* Dev */:
        case "ppe" /* PPE */:
        case "prodprv" /* ProdPrv */:
            return 'Automation';
        case "prod" /* Prod */:
        case "bfprod" /* BFProd */:
        case "pfprod" /* PFProd */:
        case "tbprod" /* TBProd */:
        case "unprod" /* UNProd */:
        case "usprod" /* USProd */:
            if (isCorpNet) {
                return 'Microsoft';
            }
            return 'Production';
        default:
            return 'Automation';
    }
}
// Function to flush the queue, used after OTelLogger is initialized.
function drainQueuedEvents(isAnonymous) {
    var queuedEvents;
    if (isAnonymous) {
        queuedEvents = unAuthEventQueue.drainQueue();
        queuedEvents.forEach(function (event) {
            if (event.eventName) {
                sendUnAuthEvent(event.eventName, event.params || {});
            }
        });
    }
    else {
        queuedEvents = eventQueue.drainQueue();
        queuedEvents.forEach(function (event) {
            if (event.eventName) {
                sendEvent(event.eventName, event.params || {});
            }
        });
    }
}
/**
 * Helper function to help convert the defined telemetry fields to the OTEL DataFields.
 *
 * @param data - Additional properties for event
 */
function convertToDataFields(data) {
    return Object.keys(data)
        .filter(function (key) {
        return typeof data[key] == 'number' ||
            typeof data[key] == 'boolean' ||
            typeof data[key] == 'string';
    })
        .map(function (key) {
        var value = data[key];
        switch (typeof value) {
            case 'number':
                return makeInt64DataField(key, value);
            case 'boolean':
                return makeBooleanDataField(key, value);
            case 'string':
                return makeStringDataField(key, value);
        }
    });
}
export function isValidConfig(correlationId, sessionId, tenantId) {
    if (tenantId) {
        return isGuid(correlationId) && isGuid(sessionId) && isGuid(tenantId);
    }
    return isGuid(correlationId) && isGuid(sessionId);
}
export function endSession(isAnonymous) {
    if (isAnonymous
        ? !(unAuthLoggerEnabled && unAuthLoggerInitialized)
        : !(loggerEnabled && loggerInitialized)) {
        return;
    }
    drainQueuedEvents(isAnonymous);
    try {
        var logger = isAnonymous ? unAuthTelemetryLogger : telemetryLogger;
        logger.telemetrySinks.forEach(function (sink) {
            var _a, _b;
            (_b = (_a = sink).flush) === null || _b === void 0 ? void 0 : _b.call(_a, false);
        });
    }
    catch (e) {
        console.log(e);
    }
}
//# sourceMappingURL=OtelTelemetryService.js.map